import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/App";
import { Bot } from "lucide-react";
import { useLocale } from "@/i18n/LocaleContext";

export default function CompanionsRow() {
  const { t } = useLocale();
  const navigate = useNavigate();
  const [companions, setCompanions] = useState([]);

  useEffect(() => {
    api.get("/companions")
      .then((r) => setCompanions(r.data.companions || []))
      .catch(() => {});
  }, []);

  if (!companions.length) return null;

  return (
    <div className="mb-6" data-testid="companions-row">
      <p className="text-sm font-medium text-muted-foreground mb-3 flex items-center gap-2">
        <Bot className="w-4 h-4 text-violet-400" /> {t("discover.companionsTitle")}
      </p>
      <div className="flex gap-4 overflow-x-auto pb-1">
        {companions.map((c) => (
          <button
            key={c.user_id}
            onClick={() => navigate(`/profile/${c.user_id}`)}
            className="flex flex-col items-center gap-1.5 shrink-0 group"
            data-testid={`companion-chip-${c.user_id}`}
          >
            <div className="w-16 h-16 rounded-full p-[2px] bg-gradient-to-tr from-violet-500 to-fuchsia-400 group-hover:scale-105 transition-transform">
              <img
                src={c.photos?.[0] || c.picture}
                alt={c.name}
                className="w-full h-full rounded-full object-cover border-2 border-background"
              />
            </div>
            <span className="text-xs text-white/80 max-w-[70px] truncate">{c.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
